/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { HTMLAttributes, useEffect, useState } from 'preact/compat';
import { Container } from '@adobe-commerce/elsie/lib';
import { NegotiableQuoteTemplateModel } from '@/quote-management/data/models/negotiable-quote-template-model';
import { events } from '@adobe-commerce/event-bus';
import { QuoteHistoryLog as QuoteHistoryLogComponent } from '@/quote-management/components/QuoteHistoryLog';

export interface QuoteTemplateHistoryLogProps extends HTMLAttributes<HTMLDivElement> {
  templateData?: NegotiableQuoteTemplateModel;
}

export const QuoteTemplateHistoryLog: Container<QuoteTemplateHistoryLogProps> = ({
  templateData: initialData,
  ...props
}) => {
  const [templateData, setTemplateData] = useState<NegotiableQuoteTemplateModel | undefined>(initialData);

  useEffect(() => {
    const templateDataEvent = events.on('quote-management/quote-template-data', (payload) => {
      setTemplateData(payload.quoteTemplate);
    }, { eager: true });

    return () => templateDataEvent?.off();
  }, []);

  if (!templateData) {
    return null;
  }

  return (
    <div {...props}>
      <QuoteHistoryLogComponent 
        history={templateData.history}
        items={templateData.items}
        buyer={templateData.buyer}
        salesRepName={templateData.salesRepName}
      />
    </div>
  );
};
